import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import { useDispatch } from 'react-redux';

import { editUser } from '../store/actions/auth';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  button: {
    width: '40%',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const SupervisorCell = ({ users, column, rowValue }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [supervisorList, setSupervisorList] = useState([]);
  const [user, setUser] = useState();
  const [chosenSupervisor, setChosenSupervisor] = useState();

  useEffect(() => {
    if (users) {
      const filtered = users.filter((checkUser) => checkUser.role && checkUser.role.name === 'Supervisor');
      setSupervisorList(filtered);
    }
  }, [users]);

  useEffect(() => {
    if (rowValue) {
      setUser(rowValue.user);
      setChosenSupervisor(rowValue.user.supervisor);
    }
  }, [rowValue]);

  const handleClose = () => {
    setIsEditing(false);
    setChosenSupervisor(user.supervisor);
  };

  const handleSubmit = () => {
    const body = {
      ...user,
      phone_number: user.phone_number || '',
      patients: user.patients.map((patient) => patient.id),
      supervisor: chosenSupervisor.id,
    };
    dispatch(editUser(body, body.id, false));
    setIsEditing(false);
  };

  const supervisorCell = () => {
    return <TableCell align={column.align} className={classes.cell} />;
  };

  const hcpCell = () => {
    return (
      <TableCell align={column.align} className={classes.cell}>
        {user.supervisor ? `${user.supervisor.first_name} ${user.supervisor.last_name}` : ''}
        <IconButton onClick={() => setIsEditing(true)} edge="end">
          <EditIcon />
        </IconButton>
      </TableCell>
    );
  };

  return (
    <Fragment>
      {user && user.role && user.role.name === 'HCP' ? hcpCell() : supervisorCell()}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isEditing}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
      >
        <Fade in={isEditing}>
          <div className={classes.paper}>
            {user && (
              <div>
                <h2 className={classes.title}>{`Select a Supervisor for ${user.first_name} ${user.last_name}`}</h2>
                <Autocomplete
                  options={supervisorList}
                  className={classes.field}
                  getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                  id="auto-complete"
                  getOptionSelected={(option, value) => option.id === value.id}
                  autoComplete
                  defaultValue={user.supervisor}
                  onChange={(event, newValue) => setChosenSupervisor(newValue)}
                  renderInput={(params) => <TextField {...params} label="Supervisor" margin="normal" />}
                />
                <div className={classes.buttonRow}>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleSubmit}
                    disabled={!chosenSupervisor}
                  >
                    Save
                  </Button>
                  <Button variant="contained" className={classes.button} onClick={handleClose}>
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Fade>
      </Modal>
    </Fragment>
  );
};

export default SupervisorCell;
